<template>
  <div class="user-box-list-page">
    <a-card class="user-box-list-card" >
      <a-form layout="inline">
        <a-form-item :label="$t('parameterAdd')"><a-input v-model.trim="queryForm['SHEET_CODE']" @keyup.enter.native="query"/></a-form-item>
        <a-form-item :label="$t('transportNumber')"><a-input v-model.trim="queryForm['SHEET_CODE']" @keyup.enter.native="query"/></a-form-item>
        <a-form-item :label="$t('transportationService')"><a-input v-model.trim="queryForm['SHEET_CODE']" @keyup.enter.native="query"/></a-form-item>
        <a-form-item :label="$t('transportationType')">
          <dol-select
              v-model="queryForm.GOODS_TYPE"
              source="server"
              server-type="DotNet"
              dot-net-table-name="BM_BASE_CODE"
              label-field="CODE_NAME"
              key-field="CODE_ID"
              value-field="CODE_ID"
              :query-data="$api.baseCode['10000013']"
          />
        </a-form-item>
        <a-form-item>
          <a-space>
            <a-button type="primary" @click="query">{{ $t('search') }}</a-button>
            <a-button  @click="clearObj">{{ $t('reset') }}</a-button>
          </a-space>
        </a-form-item>
      </a-form>
    </a-card>
    <dol-list
        :title="$t('transportationManagement')"
        :columns="columns"
        dot-net-query-type="4004"
        dotNetReturnListField="OT_SHEET_MASTER"
        :dot-net-table-type="4"
        :dot-net-table-name="tableName"
        :dot-net-columns="false"
        :row-key="primaryKey"
        :query-data="queryForm"
        ref="list"
    >
      <template #operation="field, record">
        <a-space>
<!--          <a-button type="primary" @click="gotoApply(record)">查看详情</a-button>-->
        </a-space>
      </template>
      <template #OPER_STATUS="field, record">
        <dol-dict :option="field" code="2009" valueField="DIC_CODE_DESC" />
      </template>
      <template #PRICE_STATUS="field, record">
        <dol-dict :option="field" code="2010" valueField="DIC_CODE_DESC"/>
      </template>
      <template #city="field, record">
        <span>{{record.CITY_NAME}}<a-icon style="margin: 0 4px" type="swap-right" />{{record.D_CITY_NAME}}</span>
      </template>
      <template #num="field, record">
        {{field}}
      </template>
      <template #extra>
<!--        <dol-button @click="$router.push('boxApplyForm')">-->
<!--          <a-icon type="plus"/>-->
<!--        </dol-button>-->
      </template>
    </dol-list>
    <a-modal v-model.trim="reasonVisible" :title="$t('withdrawTheClaim')" :okText="$t('confirm')" :cancelText="$t('cancel')" @ok="repealApply()" centered>
      <a-textarea v-model.trim="DELETE_DESC" :placeholder="$t('pleaseEnterTheReasonForCancellation')" :auto-size="{ minRows: 6 }" />
    </a-modal>
  </div>
</template>

<script>
import commonErpPageScript from '@/components/common/commonErpPageScript';

export default {
  name: "transport",
  mixins: [commonErpPageScript],
  data(){
    return {
      tableName: 'JT_COMPANY_PRICE',
      primaryKey: 'FLOW_ID',
      listData: [],
      queryForm:{
        QUERY_TYPE: 0,
        "COMPANY_ID":this.$store.state.userInfo.COMPANY_ID,
        "CITY_ID":"",
        "D_CITY_ID":"",
        "BOX_SIZE": "",
        "SHEET_CODE": "",
        "OPER_STATUS": "",
      },
      reasonVisible: false,
      DELETE_DESC: '',
      MASTER_ID:''
    }
  },
  computed: {
    columns(){
      let columns = [];
      columns.push({ dataIndex: 'FLOW_ID', title: this.$t('parameterAdd') });
      columns.push({ dataIndex: 'SHEET_TYPE_NAME', title: this.$t('transportationType') });
      columns.push({ dataIndex: 'SHEET_CODE', title: this.$t('transportNumber') });
      columns.push({ dataIndex: 'SHIP_NAME', title: this.$t('transportationService') });
      columns.push({ dataIndex: 'REAL_QTY', title: this.$t('通用_箱量') ,scopedSlots:{customRender:'num'}});
      return columns;
    },
  },
  methods:{
    gotoApply(data){
      this.$router.push({
        name:'boxApplyForm',
        query:{
          MASTER_ID: JSON.stringify(data.MASTER_ID),
        }
      })
    },
    //待平台报价
    repealApply(){
      this.$h5Api({
        type:'4006',
        data: [{"MASTER_ID":this.MASTER_ID,"DELETE_DESC": this.DELETE_DESC}],
        showMessage: true
      }).then(data =>{
        this.reasonVisible = false;
        this.$message.info(data.message);
      })
    },
    openRepealModel(MASTER_ID){
      this.reasonVisible = true
      this.MASTER_ID = MASTER_ID
    },
    afterClearObj(data){
      data.QUERY_TYPE=0,
      data.COMPANY_ID=this.$store.state.userInfo.COMPANY_ID;
    }
  }
}
</script >
<style scoped lang="scss">
</style>

<style scoped lang="scss">
.user-box-list-page{
  .user-box-list-card{
    margin-bottom: 24px;
  }
  .wait-frame-button{
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #1F6CBA;
    color:#1F6CBA ;
  }
}

</style>